module.exports = __webpack_public_path__ + "static/outdoor-5db28c62f6b8b13ac0c2689bd99bdc56.jpg";